/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
  UPDATE_THEME(state, val) { state.theme = val },
  UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////



  // Updates user info in state and localstorage
  async SET_USER_INFO(state, user) {
    state.user = user
    if (user) {
      axios.defaults.headers.common['Authorization'] = `bearer ${user.token}`
      // Get Data localStorage  
      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.user
      for (const property of Object.keys(user)) {

        if (user[property] != null) {
          // If some of user property is null - user default property defined in state.AppActiveUser
          state.user[property] = user[property]

          // Update key in localStorage
          userInfo[property] = user[property]
        }


      }
      //console.log('State User:',state.user)
      //console.log('LocalStorage:',userInfo)
      // Store data in localStorage 
      localStorage.setItem("userInfo", JSON.stringify(userInfo))


    } else {
      delete axios.defaults.headers.common['Authorization']
    }

  },

  // Updates

  async SET_LAST_UPDATES(state, lastUpdates) {
    state.lastUpdates = lastUpdates
  },

  // Products

  async SET_PRODUCTS(state, products) {
    state.products = products
  },

  async UPDATE_PRODUCT(state, product) {
    const index = state.products.findIndex((p) => p.codigo == product.codigo)
    Object.assign(state.products[index], product)
  },

  // Orders

  async SET_ORDERS(state, orders) {
    state.orders = orders
  },

  // Customers

  async SET_CUSTOMERS(state, customers) {
    state.customers = customers
  },

  // Carriers

  async SET_CARRIERS(state, carriers) {
    state.carriers = carriers
  },

  async ADD_CARRIER(state, carrier) {
    state.carriers.push(carrier)
    state.carriers.sort((a, b) => a.razaoSocial.localeCompare(b.razaoSocial))
  },

  async UPDATE_CARRIER(state, carrier) {
    const index = state.carriers.findIndex((p) => p.idTransportadora == carrier.idTransportadora)
    Object.assign(state.carriers[index], carrier)
  },

  // Importations
  async SET_IMPORTATIONS(state, importation) {
    state.importations = importation
  },


}

export default mutations